<template>
  <b-modal @shown="load" v-model="show" @hidden="hidden" title="Printer bewerken" centered>
    <b-overlay :show="loading">
      <b-form-group label="Model:">
        <treeselect
          :options="brands.nodes"
          disableBranchNodes
          showCount
          v-model="modelId"
          :clearable="false"
        />
      </b-form-group>
    </b-overlay>

    <template v-slot:modal-footer="{cancel, ok}">
      <b-btn @click="cancel">Annuleren</b-btn>
      <busy-btn :busy="busy" variant="primary" @click="save(ok)">Opslaan</busy-btn>
    </template>
    
  </b-modal>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import isString from 'lodash/isString';
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {CACHE_AND_NETWORK, NETWORK_ONLY} from '@/lib/constants';
import BusyBtn from '@/components/BusyBtn';


export default
{
    apollo:
    {
        brands:
        {
            query: require('../graphql/query/models_dropdown.gql'),
            skip() { return !isString(this.id); }
        }
    },
    components: { BusyBtn, Treeselect },
    computed:
    {
        show:
        {
            get() { return this.value },
            set(v) { this.$emit('input', v); }
        }
    },
    data()
    {
        return {
            busy: false,
            loading: true,
            brands: { nodes: [] },
            modelId: ''
        }
    },
    methods:
    {
        hidden()
        {
            this.busy = false;
            this.loading = true;
        },
        async load()
        {
            const { data: { printerById } } = await this.$apollo.query(
                {
                    query: require('../graphql/query/printerForEdit.gql'),
                    variables: { id: this.id },
                    fetchPolicy: NETWORK_ONLY
                }
            );
            
            this.modelId = printerById.model.id;
            
            this.loading = false;
        },
        async save(ok)
        {
            this.busy = true;
            
            const variables = 
            {
                id: this.id,
                patch: { model: { connectById: { id: this.modelId } } }
            };
            
            await this.$apollo.mutate(
                {
                    mutation: require('../graphql/mutation/updatePrinter.gql'),
                    variables
                }
            );

            return ok();
        }
    },
    props:
    {
        id: { type: String, required: false },
        value: { type: Boolean, required: true }
    }
}
</script>

<style>
</style>